import { COUNTRY_CODES } from "../../../../config/constants";
import loginModel from "../../../../models/login.model";
import ViewBase from "../../../view-base.view";
import SMSLogSavinaView from "./sms-log-savina.view";
import SMSLogSmeView from "./sms-log-sme.view";

/**
 * SMS Log
 *
 *
 * @author cmc.kmduc1(Henry)
 */

export default function SMSLogView() {
  ViewBase.call(this);

  return {
    view: () => {
      if (loginModel.credentials.country == COUNTRY_CODES.MALAYSIA) {
        return m(SMSLogSmeView)
      } else if (loginModel.credentials.country == COUNTRY_CODES.VIETNAM) {
        return m(SMSLogSavinaView)
      }
    }
  };
}
